<template>
  <v-snackbar
    v-model="show"
    :color="toast.color"
    :timeout="timeout"
    bottom
    right
    :multi-line="toast.multiLine"
    :vertical="toast.vertical"
    :absolute="toast.absolute"
    :outlined="toast.outlined"
    class="custom-snackbar"
  >
  <div class="snackbar-content">
    {{ toast.message }}
    <v-icon @click="closeSnackbar">mdi-close-box</v-icon>
  </div>
  </v-snackbar>
</template>

<script>
import { useSnackbarStore } from '../store/snackbar';


/**
 * @description Snackbar component - used for displaying messages to the user
 * @module components/Snackbar
 * @vue-prop {string} propMessage - message to display
 * @vue-prop {string} propColor - color of the snackbar
 * @vue-prop {boolean} propShow - show the snackbar
 * @vue-data {object} toast - object containing snackbar properties
 * @vue-data {number} timeout - timeout for the snackbar
 * @vue-data {boolean} show - visibility of the snackbar
 * @vue-methods closeToast - emit close event
 */

export default {
  props: {
    propMessage: String,
    propColor: String,
    propShow: Boolean,
  },

  data() {
    return {
      toast: {
        
        message: this.propMessage,
        color: this.propColor,
        multiLine: false,
        vertical: false,
        absolute: false,
        outlined: false
      },
      timeout: 2000,
      show: this.propShow,
    }
  },

  watch: {
    show() {
      if (!this.show){
      useSnackbarStore().closeSnackbar();}
    }
  },

  methods: {
    closeSnackbar() {
      useSnackbarStore().closeSnackbar()
    },

    handleSnackbarChange() {
      console.log(this.show)
      useSnackbarStore().closeSnackbar();
      
    },
  }
}
</script>

<style scoped>
.custom-snackbar {
  max-width: auto;
  min-width: 0;
  padding: 0;
}
.snackbar-content {
  display: flex;
  align-items: center;
  padding: 6px 16px;
  font-size: 1.25rem;
}
</style>